import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import DropdownBox from '../../components/Dropdown/DropdownBox/DropdownBox';
import Option from '../../components/Dropdown/DropdownOption/DropdownOption';
import { getInDomain } from '../../domains/externalUtils';

export const BackstagePodcastAllEpisodesSortDropdownKey = Symbol(
  'BackstagePodcastAllEpisodesSortDropdown',
);

class BackstagePodcastAllEpisodesSortDropdown extends React.Component {
  static propTypes = {
    childProps: PropTypes.shape({
      onSortClicked: PropTypes.func,
      sortTypes: PropTypes.object,
      activeSort: PropTypes.string,
    }),
    dropdownType: PropTypes.any,
    closeDropdown: PropTypes.func,
    intl: PropTypes.object,
  };

  constructor(props) {
    super(props);

    this.messages = getInDomain('podcast.constants.messages');
  }

  getOptions = () => {
    return this.props.childProps.sortTypes.map(sortType => {
      const props = {
        label: <FormattedMessage {...this.messages[sortType]} />,
        callback: () => this.props.childProps.onSortClicked(sortType),
        extrasStyles: ['DropdownOption--black'],
        isSelected: sortType === this.props.childProps.activeSort,
        isSelectable: true,
      };

      return <Option key={sortType} {...props} />;
    });
  };

  render() {
    return <DropdownBox menuType={this.props.dropdownType}>{this.getOptions()}</DropdownBox>;
  }
}

export const constructors = {
  [BackstagePodcastAllEpisodesSortDropdownKey]: BackstagePodcastAllEpisodesSortDropdown,
};
